import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  defaultArticles: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_DEFAULT_PCC_ARTICLES:
      return {
        ...state,
        isLoading: true,
        error: false,
        defaultArticles: [],
      };
    case types.RECEIVED_DEFAULT_PCC_ARTICLES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        defaultArticles: [],
      };
    case types.RECEIVED_DEFAULT_PCC_ARTICLES:
      return {
        ...state,
        isLoading: false,
        error: false,
        defaultArticles: action.payload,
      };
    default:
      return state;
  }
}
